"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotePaymentMethod = exports.StripeCC = exports.PayfabricCC = exports.PayhawkStoredCC = exports.PayhawkNewCC = exports.CCPaymentMethod = exports.BillToInvoice = exports.ePaymentMethodType = exports.CreditCardPayment = exports.InvoicePayment = exports.UnknownPayment = exports.ePaymentProcessor = exports.ePaymentType = void 0;
const payment_1 = __importDefault(require("./payment"));
const paymentMethod_1 = __importDefault(require("./paymentMethod"));
var ePaymentType;
(function (ePaymentType) {
    ePaymentType["UNKNOWN"] = "UNKNOWN";
    ePaymentType["INVOICE"] = "INVOICE";
    ePaymentType["CREDIT_CARD"] = "CREDIT_CARD";
})(ePaymentType = exports.ePaymentType || (exports.ePaymentType = {}));
var ePaymentProcessor;
(function (ePaymentProcessor) {
    ePaymentProcessor["PAYHAWK"] = "PAYHAWK";
    ePaymentProcessor["PAYFABRIC"] = "PAYFABRIC";
    ePaymentProcessor["STRIPE"] = "STRIPE";
})(ePaymentProcessor = exports.ePaymentProcessor || (exports.ePaymentProcessor = {}));
class UnknownPayment extends payment_1.default {
    constructor() {
        super(...arguments);
        this.type = ePaymentType.UNKNOWN;
    }
}
exports.UnknownPayment = UnknownPayment;
class InvoicePayment extends payment_1.default {
    constructor() {
        super(...arguments);
        this.type = ePaymentType.INVOICE;
    }
}
exports.InvoicePayment = InvoicePayment;
class CreditCardPayment {
    constructor(processor, transactionId) {
        this.processor = processor;
        this.transactionId = transactionId;
        this.type = ePaymentType.CREDIT_CARD;
    }
}
exports.CreditCardPayment = CreditCardPayment;
var ePaymentMethodType;
(function (ePaymentMethodType) {
    ePaymentMethodType["BILL_TO_INVOICE"] = "BILL_TO_INVOICE";
    ePaymentMethodType["PAYHAWK_NEW_CC"] = "PAYHAWK_NEW_CC";
    ePaymentMethodType["PAYHAWK_STORED_CC"] = "PAYHAWK_STORED_CC";
    ePaymentMethodType["PAYFABRIC_CC"] = "PAYFABRIC_CC";
    ePaymentMethodType["STRIPE_CC"] = "STRIPE_CC";
    ePaymentMethodType["QUOTE"] = "QUOTE";
})(ePaymentMethodType = exports.ePaymentMethodType || (exports.ePaymentMethodType = {}));
class BillToInvoice extends paymentMethod_1.default {
    constructor() {
        super(...arguments);
        this.type = ePaymentMethodType.BILL_TO_INVOICE;
    }
}
exports.BillToInvoice = BillToInvoice;
class CCPaymentMethod extends paymentMethod_1.default {
}
exports.CCPaymentMethod = CCPaymentMethod;
class PayhawkNewCC extends CCPaymentMethod {
    constructor(paymentToken, cardHolderName, store, setAsDefault) {
        super();
        this.paymentToken = paymentToken;
        this.cardHolderName = cardHolderName;
        this.store = store;
        this.setAsDefault = setAsDefault;
        this.type = ePaymentMethodType.PAYHAWK_NEW_CC;
    }
}
exports.PayhawkNewCC = PayhawkNewCC;
class PayhawkStoredCC extends CCPaymentMethod {
    constructor(id, maskedCardNumber, expirationDate, cardHolderName) {
        super();
        this.id = id;
        this.maskedCardNumber = maskedCardNumber;
        this.expirationDate = expirationDate;
        this.cardHolderName = cardHolderName;
        this.type = ePaymentMethodType.PAYHAWK_STORED_CC;
    }
    static fromObj(data) {
        const { id, maskedCardNumber, expirationDate, cardHolderName } = data;
        return new PayhawkStoredCC(id, maskedCardNumber, expirationDate, cardHolderName);
    }
}
exports.PayhawkStoredCC = PayhawkStoredCC;
class PayfabricCC extends CCPaymentMethod {
    constructor() {
        super(...arguments);
        this.type = ePaymentMethodType.PAYFABRIC_CC;
    }
}
exports.PayfabricCC = PayfabricCC;
class StripeCC extends CCPaymentMethod {
    constructor(intentId) {
        super();
        this.intentId = intentId;
        this.type = ePaymentMethodType.STRIPE_CC;
    }
    static fromObj(data) {
        const { intentId } = data;
        return new StripeCC(intentId);
    }
}
exports.StripeCC = StripeCC;
class QuotePaymentMethod extends paymentMethod_1.default {
    constructor() {
        super(...arguments);
        this.type = ePaymentMethodType.QUOTE;
    }
}
exports.QuotePaymentMethod = QuotePaymentMethod;
//# sourceMappingURL=index.js.map